import { useState, FC, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import Components from "./Component";

import ShipperContext from "../context";

//Types
import { LogisticListInterface, OrderCreatedInterface, AddressInterface } from "../definitions";
import { WrapperProps } from "./definitions";

//actions
import { getListAddress } from "../../../../actions/shipperAction";

const ShipperWrapper: FC<WrapperProps> = ({
  isOpen,
  shipperData,
  currency,
  ratio,
  sale_id,
  seller_responded,
  isConsignments,
  onHide,
  submitDropoff,
  onHideAndUpdate
}): JSX.Element => {
  const [process, setProcess] = useState("")
  const [selectedLogistic, setSelectedLogistic] = useState<LogisticListInterface | null>(null)
  const [pickupCreatedData, setPickupCreatedData] = useState<null | OrderCreatedInterface>(null)
  const [selectedAddress, setSelectedAddress] = useState<AddressInterface | null>(null)

  const [addresses, setAddresses] = useState<Array<AddressInterface>>([])
  const [defaultAddress, setDefaultAddress] = useState<AddressInterface | null>(null)

  const order_id = pickupCreatedData?.order_id || shipperData?.order_id;

  /**Handlers */
  // setProcessHandler
  const toDeliveryMethod = () => setProcess("delivery-method");
  const toPickupAddress = () => setProcess("pickup-address");
  const toSelectLogistic = () => setProcess("select-logistic");
  const toOutOfReach = () => setProcess("out-of-reach");
  const toLogisticConfirmation = () => setProcess("logistic-confirmation");
  const toPickupCreated = () => setProcess("pickup-created");
  const toPickupScheduled = () => setProcess("pickup-scheduled");
  const toPickupNotes = () => setProcess("pickup-notes");
  const toPickupScheduledDetails = () => setProcess("pickup-scheduled-details")
  const toRequestCancelPickup = () => setProcess("request-cancel-pickup");
  const toPickupCancelled = () => setProcess("pickup-cancelled");
  const toPickupDetails = () => setProcess("pickup-details");
  const toPickupLocation = () => setProcess("pickup-location");

  //continueHandler
  const deliveryMethodContinue = (args: string, addresses?: Array<AddressInterface>, defaultAddress?: AddressInterface) => {
    setDefaultAddress(defaultAddress || null)
    setAddresses(addresses || [])

    setProcess(args)
  };

  const pickupAddressContinue = (address: AddressInterface | null) => {
    setSelectedAddress(address)
    toSelectLogistic();
  };

  const selectLogisticContinue = (data: LogisticListInterface) => {
    setSelectedLogistic(data)
    toLogisticConfirmation()
  }

  const logisticConfirmationContinue = (data: OrderCreatedInterface) => {
    setPickupCreatedData(data)
    toPickupCreated()
  }

  //---remove this after develop
  const submitDropoffHandler = () => submitDropoff();

  //backHandler
  const selectLogisticBack = () => {
    setSelectedLogistic(null)
    toPickupAddress()
  }

  const logisticConfirmationBack = () => {
    setPickupCreatedData(null)
    toSelectLogistic()
  }

  const onHideHandler = () => {
    switch (process) {
      case "pickup-created":
      case "pickup-scheduled":
      case "pickup-notes":
      case "pickup-scheduled-details":
      case "request-cancel-pickup":
      case "pickup-cancelled":
      case "pickup-details": {
        onHideAndUpdate()
        break;
      }
      default: {
        onHide()
        break
      }
    }
  };

  const initProcess = () => {
    if (!shipperData) return toDeliveryMethod();
    const _status = shipperData?.status;

    /**
     * NEW -> Order made but user not yet request to pickup
     * PICKUP_REQUESTED -> User has made request pickup but the package not taken yet
     * PICKED_UP -> Package has taken by courier
     * DELIVERED -> Package arrives at the destination
     * CANCELLED -> Pickup Cancelled
     */
    switch (_status) {
      case "NEW": {
        toPickupCreated()
        break;
      }
      case "PICKUP_REQUESTED":
      case "PICKED_UP":
      case "DELIVERED": {
        toPickupLocation()
        break;
      }
      case "CANCELLED": {
        setProcess("pickup-cancelled")
        break;
      }
      default: return setProcess("delivery-method")
    }
  }

  const fetchAddressList = async (onMount?: boolean) => {
    try {
      await getListAddress()
        .then(res => res?.data)
        .then(res => {
          setAddresses(res?.data)
        })
        .catch(err => { throw err })
    } catch (err) {
      console.log(err, "Error when fething address list")
    }
  }

  useEffect(() => {
    initProcess()
  }, [])


  if (!process) return <div />;
  return (
    <ShipperContext.Provider value={{ currency, ratio }}>
      <Components
        isOpen={isOpen}
        sale_id={sale_id}
        order_id={order_id}
        process={process}
        seller_responded={seller_responded}
        isConsignments={isConsignments}
        selectedAddress={selectedAddress}
        selectedLogistic={selectedLogistic}
        pickupCreatedData={pickupCreatedData || shipperData}
        addresses={addresses}
        defaultAddress={defaultAddress}
        pickupUnmountCallback={fetchAddressList}
        onHideAndUpdate={onHideAndUpdate}
        pickupAddressContinue={pickupAddressContinue}
        deliveryMethodContinue={deliveryMethodContinue}
        submitDropoffHandler={submitDropoffHandler}
        selectLogisticContinue={selectLogisticContinue}
        selectLogisticBack={selectLogisticBack}
        logisticConfirmationContinue={logisticConfirmationContinue}
        logisticConfirmationBack={logisticConfirmationBack}
        onHideHandler={onHideHandler}
        toOutOfReach={toOutOfReach}
        toPickupAddress={toPickupAddress}
        toPickupScheduled={toPickupScheduled}
        toPickupNotes={toPickupNotes}
        toPickupScheduledDetails={toPickupScheduledDetails}
        toPickupDetails={toPickupDetails}
        toDeliveryMethod={toDeliveryMethod}
        toPickupCreated={toPickupCreated}
        toRequestCancelPickup={toRequestCancelPickup}
        toPickupCancelled={toPickupCancelled}
      />
    </ShipperContext.Provider>
  )
}
ShipperWrapper.defaultProps = {
  isOpen: false,
  onHide: () => { },
  submitDropoff: () => { }
}

export default ShipperWrapper;